import { IOfferState } from '../../redux/reducers';
import { isAreaPartsEmpty } from './isAreaPartsEmpty';

/** Определяет разделяемость объекта на части (опция «Можно частями») */
export const isObjectSplits = (offer: IOfferState) => {
  return !isAreaPartsEmpty(offer);
};
